import { Account } from '@/domain/usecases'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import RegisteredPlanBaseLoader from '../registered-plan-base-loader'
import { dependentRequestService } from '@/data/services/dependent/dependent-service'

export default class DependentRequestLoader extends RegisteredPlanBaseLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined
  ) {
    super(account, queryClient, ldClient)
  }

  async loader() {
    const [dependentSettings, dependentRequestStatus] = await Promise.all([
      dependentRequestService.fetchSettings(this.account.company.uniqueId),
      dependentRequestService.fetchPendingRequests(this.account.company.uniqueId)
    ])

    const plans = dependentSettings.plans?.filter(plan => plan.enabled) ?? []
    const degreesKinship = dependentSettings.degreesKinship?.filter(degree => degree.allowed) ?? []

    const response = {
      ...dependentSettings,
      plans,
      degreesKinship,
      pendingResponse: dependentRequestStatus
    }

    return this.defer({ data: response })
  }
}
